import { Pagination, Table } from "antd";
import { ColumnGroupType, ColumnType, TableProps } from "antd/es/table";
import { IOptionPaginateTable } from "interfaces";
import * as React from "react";

export interface IAppProps<T> {
  loading?: boolean;

  header?: () => React.ReactNode;

  columns: TableProps<T>["columns"];
  content?: (ColumnGroupType<T> | ColumnType<T>)[];
  data: TableProps<{ key: string } & Partial<T>>["dataSource"];
  onClick?: (record: T) => void;

  body?: () => React.ReactNode;

  footer?: () => React.ReactNode;
  optionPaginate?: IOptionPaginateTable;
}

export default function LayoutTableV2Presenter<Model>(props: IAppProps<Model>) {
  const renderPaginate = () => {
    if (!props.optionPaginate) return <></>;
    const { pageNum, pageSize, numberRecordShow, totalRecord, onChangePageNum, onShowSizeChange, title } =
      props.optionPaginate;

    return (
      <React.Fragment>
        <div className="list-count">
          Hiển thị <span className="bold">{numberRecordShow}</span> của <span className="bold">{totalRecord}</span>{" "}
          {title || "bài viết"}
        </div>
        <Pagination
          total={totalRecord}
          onChange={onChangePageNum}
          defaultPageSize={pageSize}
          pageSize={pageSize}
          current={pageNum || 1}
          onShowSizeChange={onShowSizeChange}
        />
      </React.Fragment>
    );
  };

  const renderContent = () => {
    return (
      <Table
        loading={props.loading}
        columns={props.columns?.map((column) => ({ ...column, width: 100 })) as any}
        dataSource={props.data}
        pagination={false}
        scroll={{ x: 1200 }}
        style={{ width: "100%" }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              props.onClick && props.onClick(record as Model);
            }, // click row
          };
        }}
      />
    );
  };

  return (
    <div className="layout-list">
      <div className="layout-list__header">{props.header && props.header()}</div>
      <div className="layout-list__content">{props.body ? props.body() : renderContent()}</div>

      <div className="layout-list__footer">
        {props.footer && props.footer()}
        {props.optionPaginate && renderPaginate()}
      </div>
    </div>
  );
}
